// Histórico de compras de um ingrediente, a partir de /purchases/grouped.

export function comprasDoIngrediente(lotes, ingredienteId, { ignorarLote } = {}) {
  const lista = [];
  for (const lote of lotes || []) {
    if (!lote || lote.batch_id === ignorarLote) continue;
    for (const p of lote.items || lote.purchases || []) {
      if (p.ingredient_id !== ingredienteId) continue;
      const qtd = Number(p.quantity) || 0;
      const total = Number(p.price) || 0;
      lista.push({
        id: p.id,
        data: String(lote.purchase_date || p.purchase_date || "").slice(0, 10),
        fornecedor: lote.supplier || p.supplier || "",
        qtd,
        total,
        unitario: Number(p.unit_price) || (qtd > 0 ? total / qtd : 0),
      });
    }
  }
  return lista.sort((a, b) => (a.data < b.data ? 1 : a.data > b.data ? -1 : 0));
}

// Mesma conta do backend (average_price): média simples do preço unitário das 5 últimas.
export function resumo(compras) {
  const ultimas = compras.slice(0, 5);
  if (!ultimas.length) return null;
  const precos = ultimas.map((c) => c.unitario);
  return {
    media: precos.reduce((s, v) => s + v, 0) / precos.length,
    contadas: ultimas.length,
    menor: Math.min(...precos),
    maior: Math.max(...precos),
    qtdMedia: ultimas.reduce((s, c) => s + c.qtd, 0) / ultimas.length,
    ultima: compras[0],
  };
}

// Diferença do preço em relação à média: +8.2 = 8,2% mais caro.
export function variacao(preco, media) {
  if (!(preco > 0) || !(media > 0)) return null;
  return ((preco - media) / media) * 100;
}

export const dataBR = (iso) => {
  const [y, m, d] = String(iso || "").slice(0, 10).split("-");
  return y && m && d ? `${d}/${m}/${y}` : "";
};
